import { j as r } from "./atoms-v218.js";
import { Wrapper as p, CVVContainer as d, CvvInput as m, SaveButton as v } from "./atoms-v21043.js";
import { useState as u } from "react";
import { Icon as x } from "./atoms-v217.js";
const f = (o) => {
  const [e, n] = u(""), { cvvError: s, isLoading: t, paymentHeader: a, setCVV: i, translations: l } = o;
  return /* @__PURE__ */ r.jsx(r.Fragment, { children: /* @__PURE__ */ r.jsxs(p, { children: [
    a,
    /* @__PURE__ */ r.jsxs(d, { children: [
      /* @__PURE__ */ r.jsx(
        m,
        {
          defaultValue: e,
          disabled: t,
          error: s,
          label: "CVV",
          onChange: (c) => n(c.target.value),
          tooltip: l.cvvTooltip
        }
      ),
      /* @__PURE__ */ r.jsx(v, { iconOnly: !0, disabled: t, onClick: () => i(e), shape: "square", children: /* @__PURE__ */ r.jsx(x, { name: "arrow-right" }) })
    ] })
  ] }) });
};
export {
  f as SecurityCode
};
